import React from 'react';

import ErrorPage, { contactUsAction } from '~/components/ErrorPage';
import { createTranslate } from '~/utils/translation';

import criticalError from 'images/500.svg';


const tt = createTranslate('routes.critical_error');


const CriticalError = () => (
  <ErrorPage image={criticalError} title={tt('title')} subtitle={tt('subtitle')} action={contactUsAction()} />
);


export default CriticalError;
